import Compressor from "compressorjs";
import { imageDb, removeImage, store } from "../store";

export const getCompressedImage = async (file: File | Blob, quality: number): Promise<File | Blob> => {
    return new Promise((resolve, reject) => {
        new Compressor(file, {
            quality: quality,
            success: resolve,
            error: reject,
        });
    });
}

export const fileToBase64 = async (file: File | Blob, quality?: number): Promise<string | null> => {
    if (quality && quality < 1) {
        file = await getCompressedImage(file, quality);
    }

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result?.toString() ?? null);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export const removeUnusedImages = async () => {
    console.log('Removing  unused images...');
    const state = store.getState();
    const referencedFileIds = getReferencedFileIds(state);

    const fileIds = await imageDb.keys();
    const promises: Promise<void>[] = [];
    fileIds.map(fileId => {
        if (!(referencedFileIds.includes(fileId))) {
            promises.push(removeImage(fileId));
        }
    });
    await Promise.all(promises);
    const deleteCount = promises.length;
    console.log(`Removed ${deleteCount} image${deleteCount > 1 ? 's' : ''}.`);
}

const getReferencedFileIds = (object: object): string[] => {
    return Object.entries(object).flatMap(([key, value]) => {
        if (typeof value === 'object' && value !== null) {
            return getReferencedFileIds(value);
        }
        if (key === 'fileId') {
            return value;
        }
    }).filter((value) => value);
}